import { render, staticRenderFns } from "./_SupplierMealBlock.vue?vue&type=template&id=95161a74"
import script from "./_SupplierMealBlock.vue?vue&type=script&lang=js"
export * from "./_SupplierMealBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports